import React, { useState } from 'react';
import { Label, Input, FormGroup } from 'reactstrap';
import { PageHeader } from '../common/PageHeader';
import PrescriptionMismatchTable from './PrescriptionMismatchTable';
import NavBar from '../layout/NavBar';

const MISMATCH_TYPE_OPTIONS = [
    { label: 'All Types', value: '' },
    { label: 'Patient Name', value: 'patient_name' },
    { label: 'Doctor Name', value: 'doctor_name' },
    { label: 'Hospital Name', value: 'hospital_name' },
    { label: 'Appointment Date', value: 'appointment_date' },
];

const PrescriptionMismatchHome = () => {
    const [mismatchType, setMismatchType] = useState('');

    return (
        <>
        <NavBar />
        <div style={{
            marginTop : '70px'
        }} className="container-fluid">
            <div className="row align-items-end">
                <div className="col">
                    <PageHeader>Prescription Mismatches</PageHeader>
                </div>
                <div className="col-3 pb-2">
                    <FormGroup className="mb-0">
                        <Label for="mismatchTypeFilter" className="mb-1">Filter by Type</Label>
                        <Input
                            type="select"
                            id="mismatchTypeFilter"
                            value={mismatchType}
                            onChange={(e) => setMismatchType(e.target.value)}
                        >
                            {MISMATCH_TYPE_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <PrescriptionMismatchTable mismatchType={mismatchType} />
                </div>
            </div>
        </div>
        </>
    );
};

export default PrescriptionMismatchHome;
